import {
  ToastContainer, 
  Toast, Alert 
} from 'react-bootstrap';
//import { XLg } from 'react-bootstrap-icons';
import { useDispatch } from 'react-redux';
import { ToastAction } from '../../../Redux/Actions/ToastAction';
import { IToastProps } from '../../../utils/types';

const CustomToast = (props: IToastProps) => {
  const { show, message, severity } = props;
  const dispatch = useDispatch()

  const onCloseToast = () => {
    dispatch(ToastAction({ show: false, message: '', severity: '' }))
  }

  return (
      
    <ToastContainer>
      <Toast show={show} delay={3000}  autohide onClose={onCloseToast} >
        <Alert
            variant={severity.toLowerCase()} 
            onClose={onCloseToast}
            dismissible
          >
            {message}
        </Alert>
      </Toast> 
      </ToastContainer>
  )
}

export default CustomToast